var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.3,15.4c0-0.8,0-1.6,0-2.4c0-1.3-0.9-2.2-2.2-2.2c-1.6,0-3.2,0-4.8,0c-1.3,0-2.2,0.9-2.2,2.2 c0,1.6,0,3.2,0,4.8C0.1,19.1,1,20,2.3,20c1.6,0,3.2,0,4.8,0c1.3,0,2.2-0.9,2.2-2.2C9.3,17,9.3,16.2,9.3,15.4z M10,9.4c1,0,2,0,3,0 c0.9,0,1.5-0.3,1.9-1.1c0.4-0.7,0.4-1.5-0.1-2.2c-1-1.7-2-3.3-3-5C11-0.4,9-0.4,8.1,1.1c-1,1.7-2,3.3-3,5C4.7,6.8,4.6,7.5,5,8.3 C5.4,9,6.1,9.4,7,9.4C8,9.4,9,9.4,10,9.4z M19.9,15.4c0-2.5-2.1-4.6-4.6-4.6c-2.5,0-4.6,2.1-4.6,4.6c0,2.6,2.1,4.6,4.6,4.6 C17.9,20,19.9,17.9,19.9,15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.3,15.4c0,0.8,0,1.6,0,2.4c0,1.3-0.9,2.2-2.2,2.2c-1.6,0-3.2,0-4.8,0c-1.3,0-2.2-0.9-2.2-2.2 c0-1.6,0-3.2,0-4.8c0-1.3,0.9-2.2,2.2-2.2c1.6,0,3.2,0,4.8,0c1.3,0,2.2,0.9,2.2,2.2C9.3,13.8,9.3,14.6,9.3,15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,9.4c-1,0-2,0-3.1,0C6.1,9.4,5.4,9,5,8.3C4.6,7.5,4.7,6.8,5.1,6c1-1.7,2-3.3,3-5c0.9-1.4,2.8-1.5,3.7,0 c1,1.7,2,3.3,3,5c0.4,0.7,0.5,1.5,0.1,2.2C14.6,9,13.9,9.4,13,9.4C12,9.4,11,9.4,10,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.9,15.4c0,2.5-2.1,4.6-4.6,4.6c-2.5,0-4.6-2.1-4.6-4.6c0-2.5,2.1-4.6,4.6-4.6 C17.9,10.8,19.9,12.8,19.9,15.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModel);
export default __webpack_public_path__ + "static/media/model.871bea573af03ef928393bdd16d3d4d6.svg";
export { ForwardRef as ReactComponent };